/**
 * The lender's position in the facility, as facilities-api returns it
 * (`PriorityPosition`, LEN-2555). Three keys, as LEN-1874 and LEN-1875
 * (scenario 6) set them. The worker maps companies-api's six `lender_role`s to
 * them in `_POSITION_BY_LENDER_ROLE` (trust-scheduler-worker,
 * `services/company_operation.py`): `bilateral` is `SOLE_LENDER`; `syndicated`
 * and `senior` are `SYNDICATED`; `mezzanine` and `subordinated` are
 * `SUBORDINATED`; `back-leverage` has no position and reads as not reported.
 */
export const LENDER_POSITIONS = [
  'SOLE_LENDER',
  'SYNDICATED',
  'SUBORDINATED',
] as const;

export type LenderPosition = (typeof LENDER_POSITIONS)[number];

/** How each position reads in the portfolio Overview's cuts (LEN-2363). */
export const LENDER_POSITION_LABELS: Record<LenderPosition, string> = {
  SOLE_LENDER: 'Bilateral',
  SYNDICATED: 'Syndicated',
  SUBORDINATED: 'Subordinated',
};

/** `general_elements.lender_participation` of a facility overview. */
export interface LenderParticipation {
  /** What this lender has committed in the facility; null when not reported. */
  committed_amount?: number | null;
  /**
   * The share the API derives (committed ÷ maximum credit). Not read for
   * display: `lenderSharePct` derives it from the same two amounts the card
   * shows, so the percentage and its figures can never disagree.
   */
  participation_pct?: number | null;
  /** Null when the lender's role was not reported. */
  position?: LenderPosition | null;
}
